import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Emergency = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23.834 22.071L22.624 16.02C22.158 13.691 20.096 12 17.721 12H14.279C11.904 12 9.842 13.69 9.376 16.019L8.166 22.071C5.805 22.469 4 24.527 4 27C4 27.552 4.448 28 5 28H27C27.552 28 28 27.552 28 27C28 24.527 26.195 22.469 23.834 22.071V22.071ZM11.338 16.412C11.618 15.015 12.855 14 14.28 14H17.722C19.147 14 20.384 15.014 20.664 16.412L21.782 22H10.222L11.34 16.412H11.338ZM6.171 26C6.584 24.836 7.696 24 9 24H23C24.304 24 25.416 24.836 25.829 26H6.172H6.171Z" />
		<path d="M28 17C28 17.552 27.552 18 27 18C26.448 18 26 17.552 26 17C26 16.448 26.448 16 27 16C27.552 16 28 16.448 28 17Z" />
		<path d="M6 17C6 17.552 5.552 18 5 18C4.448 18 4 17.552 4 17C4 16.448 4.448 16 5 16C5.552 16 6 16.448 6 17Z" />
		<path d="M26 9C26 8.448 25.552 8 25 8C24.724 8 24.474 8.112 24.293 8.293L22.293 10.293C22.112 10.474 22 10.724 22 11C22 11.552 22.448 12 23 12C23.276 12 23.526 11.888 23.707 11.707L25.707 9.707C25.888 9.526 26 9.276 26 9Z" />
		<path d="M7 8C6.448 8 6 8.448 6 9C6 9.276 6.112 9.526 6.293 9.707L8.293 11.707C8.474 11.888 8.724 12 9 12C9.552 12 10 11.552 10 11C10 10.724 9.888 10.474 9.707 10.293L7.707 8.293C7.526 8.112 7.276 8 7 8V8Z" />
		<path d="M16 10C15.448 10 15 9.552 15 9V5C15 4.448 15.448 4 16 4C16.552 4 17 4.448 17 5V9C17 9.552 16.552 10 16 10Z" />
	</svg>
);

export default Emergency;
